import { utils } from '@sfaas/util';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getCommCodes: param => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${param.plantCd}/commonCodes?commCdType=${param.codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getDicMsgManagements: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (
			searchParams.msgKey !== undefined ||
			searchParams.msgText !== undefined ||
			searchParams.msgType !== undefined ||
			searchParams.msgLoc !== undefined
		) {
			queryStr = utils.$sf_objectToQueryString({
				msgKey: searchParams.msgKey,
				msgText: searchParams.msgText,
				msgType: searchParams.msgType,
				msgLoc: searchParams.msgLoc,
				currentPage,
				pageUnit
			});
		}
		return client
			.get(`${BASE_URL}/message/v1/plants/${searchParams.plantCd}/messages` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getMenus: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (
			searchParams.msgLang !== undefined ||
			searchParams.parentScrId !== undefined ||
			searchParams.scrType !== undefined ||
			searchParams.useYn !== undefined
		) {
			queryStr = utils.$sf_objectToQueryString({
				msgLang: searchParams.msgLang,
				parentScrId: searchParams.parentScrId,
				scrType: searchParams.scrType,
				useYn: searchParams.useYn,
				currentPage,
				pageUnit
			});
		}
		return client
			.get(`${BASE_URL}/menu/v1/plants/${searchParams.plantCd}/screens` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getScreens: ({ plantCd, langCd }) => {
		return client
			.get(`${BASE_URL}/menu/v1/plants/${plantCd}/languages/${langCd}/screens`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getMenuKey: param => {
		return client
			.get(`${BASE_URL}/menu/v1/plants/${param.plantCd}/screens/screenId`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	postMenus: param => {
		return client
			.post(`${BASE_URL}/menu/v1/status/${param.status}/plants/${param.plantCd}/screens`, param.data)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
